import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GET } from "../../services/axios.service";
import { PartyProps, JobworkProps } from "../../types/jobwork";

export interface OpenJobworkState {
  jobworks: JobworkProps[];
  totalJobworks: number;
  parties: PartyProps[];
  selectedParty: number;
  selectedJobwork: number | null;
  loading: boolean;
  error: string | null;
}

const initialState: OpenJobworkState = {
  jobworks: [],
  totalJobworks: 0,
  parties: [],
  selectedParty: 0,
  selectedJobwork: null,
  loading: false,
  error: null,
};

export const fetchOpenJobworksData = createAsyncThunk(
  "fetchOpenJobworksData",
  async (req: {
    page: number;
    party_id?: number;
    jobwork_id?: number;
    type: number;
  }) => {
    let response: any;
    await GET(`/v1/worker/jobworks`, { ...req, status: 0, type: req.type })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

type FetchPartiesDataProps = {
  type: number;
};

export const fetchPartiesData = createAsyncThunk(
  "fetchOpenJobworksPartiesData",
  async (req: FetchPartiesDataProps) => {
    let response: any;
    await GET(`/v1/worker/jobworks-parties`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const openJobworkSliceSlice = createSlice({
  name: "openJobwork",
  initialState,
  reducers: {
    updateSelectedParty: (state, action: PayloadAction<number>) => {
      state.selectedParty = action.payload;
    },
    updateSelectedJobwork: (state, action: PayloadAction<number | null>) => {
      state.selectedJobwork = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOpenJobworksData.pending, (state, action: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchOpenJobworksData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        if (
          action.payload.data.data.records.length > 0 &&
          action.payload.data.data.page > 1
        )
          state.jobworks = [
            ...state.jobworks,
            ...action.payload.data.data.records,
          ];
        else state.jobworks = action.payload.data.data.records;
        state.totalJobworks = action.payload.data.data.total_records;
        state.error = null;
      } else {
        state.jobworks = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchOpenJobworksData.rejected, (state, action: any) => {
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
    builder.addCase(fetchPartiesData.pending, (state, action: any) => {
      state.parties = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPartiesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.parties = action.payload.data.data;
        state.error = null;
      } else {
        state.parties = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchPartiesData.rejected, (state, action: any) => {
      state.parties = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { updateSelectedParty, updateSelectedJobwork } =
  openJobworkSliceSlice.actions;

export const getJobworks = (state: RootState) => state.openJobwork.jobworks;

export const getTotalJobworks = (state: RootState) =>
  state.openJobwork.totalJobworks;

export const getParties = (state: RootState) => state.openJobwork.parties;

export const getSelectedParty = (state: RootState) =>
  state.openJobwork.selectedParty;

export const getSelectedJobwork = (state: RootState) =>
  state.openJobwork.selectedJobwork;

export default openJobworkSliceSlice.reducer;
